module.exports = __webpack_public_path__ + "img/diamong_tctext.15ea65a9.png";